module.exports = __webpack_public_path__ + "static/p3-c98a59b516f7c1614fd31e6baffca82b.png";